import React, { ChangeEvent, FormEventHandler, useEffect, useState } from 'react';
import { TextField, CheckboxField, SelectField, RadioField, NumberField, FloatField } from './fields';



export const DynamicForm= ({ fields, initialValues, handleSubmit, isSaving, setUnsavedChanges, addingEmployees, onComplete }) => {
  const [values, setValues] = useState({});
  const [initialFormValues, setInitialFormValues] = useState({});
  
  
  
  // useEffect(() => {
  //   const newState = {};
  //   if (initialValues) {
  //     // const [values, setValues] = useState<{ [key: string]: string | number | boolean }>(initialValues);

  //     // loop initial values and set them
  //     for (const key in initialValues) {
  //       newState[key] = initialValues[key];
  //     }

  //     setValues(prevState => {
  //       return { ...prevState, ...newState }
  //     });

  //   }
  // }, []);

  // const handleChange = (name) => (
  //   event
  // ) => {
  //   setValues({
  //     ...values,
  //     [name]: event.target.value,
  //   });
  // };

  useEffect(() => {
    if (initialValues) {
      setValues(initialValues);
      setInitialFormValues(initialValues);
    }
  }, [initialValues]);

  // useEffect(() => {
  //   const hasChanges = JSON.stringify(values) !== JSON.stringify(initialFormValues);
  //   setUnsavedChanges(hasChanges);
  // }, [values, initialFormValues, setUnsavedChanges]);

  const handleChange = (name) => (event) => {
    const newValue = event.target.value;

    setValues((prevValues) => {
      const updatedValues = {
        ...prevValues,
        [name]: newValue,
      };

      return updatedValues;
    });
  };

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden mb-8">
        <form onSubmit={(e) => handleSubmit(e, values)} className="rounded px-8 pt-6 pb-8 mb-4">
          {fields.map((field, i) => {
            const isRequired = field.required ? '*' : '';
            switch (field.type) {
              case 'text':
                return (
                  <TextField required={field.required} key={i} name={field.name} label={`${field.label} ${isRequired}`} value={initialValues?.[field.name] || ''} onChange={handleChange(field.name)} disabled={field.disabled ? true : false} />
                );
              case 'checkbox':
                return (
                  <CheckboxField required={field.required} key={i} name={field.name} label={field.label} value={!!values[field.name]} onChange={handleChange(field.name)}  />
                );
              case 'select':
                return (
                  <SelectField required={field.required} key={i} name={field.name} label={field.label} value={values[field.name] || ''} options={field.options || []} onChange={handleChange(field.name)} />
                );
              case 'radio':
                return (
                  <RadioField required={field.required} key={i} name={field.name} label={field.label} value={values[field.name] || ''} options={field.options || []} onChange={handleChange(field.name)} />
                );
              case 'number':
                return (
                  <NumberField required={field.required} key={i} name={field.name} label={field.label} value={values[field.name] || ''} onChange={handleChange(field.name)} />
                );
              case 'float':
                return (
                  <FloatField required={field.required} key={i} name={field.name} label={field.label} value={values[field.name] || ''} onChange={handleChange(field.name)} />
                );
              default:
                return null;
            }
          })}
          <button
            className="bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
            type="submit"
            disabled={isSaving}
          >
            {isSaving ? 'Salvataggio...' : 'Salva'}
          </button>
        </form>
      </div>
      {addingEmployees && (
        <div className='text-center pt-8'>
          <button
            onClick={() => onComplete(true)}
            className="text-indigo-600 hover:text-indigo-800 font-medium"
          >
            Torna al form precedente
          </button>
        </div>
      )}
    </>
  );
};
